import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzModalModule } from "ng-zorro-antd/modal";
import { Ng1StateProxyProvider } from "@webapp/core/provider-upgrade/providers/ng1-state.proxy";
import { FeatureToggleServiceProvider } from "@webapp/feature-toggles/providers/feature-toggle-service.provider";
import { UiModule } from "@webapp/ui/ui.module";
import { TagServiceProvider } from "./providers/tag-service.provider";
import { TagFormComponent } from "./components/tag-form/tag-form.component";
import { TagStatusComponent } from "./components/tag-status/tag-status.component";
import { InactiveTagExistsModalComponent } from "./components/inactive-tag-exists-modal/inactive-tag-exists-modal.component";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [TagFormComponent, TagStatusComponent, InactiveTagExistsModalComponent],
  imports: [UiModule, CommonModule, FormsModule, ReactiveFormsModule, NzModalModule],
  providers: [Ng1StateProxyProvider, TagServiceProvider, FeatureToggleServiceProvider],
})
export class TagsModule {}
